import { useEffect, useState } from "react";
import { fetchJobNeedTimeDescription } from "../../service";
import Label from "../../common/Label";
import HeaderTexts from "../../common/HeaderTexts";

const JobNeedTimeDescription = ({ sub_skill_id, isHome = false, isCurrentJob = false, stepFlowIsEnable=false }) => {
    const [loading, setLoading] = useState(true);
    const [description, setDescription] = useState("");

    useEffect(() => {
        const getJobNeedTimeDescription = async () => {
            // Skip API call if sub_skill_id is undefined or null
            if (sub_skill_id == null) {
                setLoading(false);
                return;
            }

            try {
                const res = await fetchJobNeedTimeDescription(sub_skill_id);
                if (res?.status === "Success" && res?.time_description) {
                    setDescription(res.time_description);
                } else {
                    setDescription("No description available for this job.");
                }
            } catch (error) {
                setDescription("Failed to load description.");
            } finally {
                setLoading(false);
            }
        };

        getJobNeedTimeDescription();
    }, [sub_skill_id]);

    if (loading) return null;

    if(isHome && stepFlowIsEnable){
        return (
            <div className={`card mb-3 h-100`}>
                <div className="card-body">
                    <HeaderTexts title="Estimated Time for a Typical Job" subTitle=""/>
                    <div dangerouslySetInnerHTML={{ __html: description || "No description available." }} />
                </div>
            </div>
        );
    }

    return (
        <div className={`mt-${isHome ? "0" : isCurrentJob ? "0 mb-3" : "4"}`}>
            <div className={`card card-frame ${(!isHome && !isCurrentJob) ? "mx-3" : ""} mb-3 ${!isCurrentJob ? "job-card-bg-color" : ""} h-100`}>
                <div className="card-body">
                    <Label text="Estimated Time for a Typical Job" />
                    <div dangerouslySetInnerHTML={{ __html: description || "No description available." }} />
                </div>
            </div>
        </div>
    );
};

export default JobNeedTimeDescription;